import React, { createContext, useContext, useState } from "react";

// Shared open-state for the TrackStars chat panel so multiple entry points
// (the floating launcher and the "Ask TrackStars" link in the transaction
// header) all control the same panel.
interface ChatOpenContextValue {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ChatOpenContext = createContext<ChatOpenContextValue | undefined>(
  undefined
);
ChatOpenContext.displayName = "Chat Open Context";

export const ChatOpenProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ChatOpenContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </ChatOpenContext.Provider>
  );
};

// Returns undefined outside a provider so entry points can render harmlessly
// (e.g. in isolated tests) without throwing.
export const useChatOpen = () => useContext(ChatOpenContext);
